import { resetStoreBankAverageCost } from '../bank/averageCost/store/slice'
import { resetStoreBankBalanceBreakdown } from '../bank/balanceBreakdown/store/slice'
import { resetStoreBankCapitalAndLeverage } from '../bank/capitalAndLeverage/store/slice'
import { resetStoreBankCashBreakdown } from '../bank/cashFlow/store/slice'
import { resetStoreBankDepositAndCredit } from '../bank/depositAndCredit/store/slice'
import { resetStoreBankEarningBreakdown } from '../bank/earningBreakdown/store/slice'
import { resetStoreBankEarningQuality } from '../bank/earningQuality/store/slice'
import { resetStoreBankFundingStructure } from '../bank/fundingStructure/store/slice'
import { resetStoreBankLiquidity } from '../bank/liquidity/store/slice'
import { resetStoreBankLoanBookBreakdown } from '../bank/loanBookBreakdown/store/slice'
import { resetStoreBankQuickAssessment } from '../bank/quickAssessment/store/slice'
import { resetStoreAssetManagementEfficiency } from '../corporate/assetManagementEfficiency/store/slice'
import { resetStoreCorpBalanceBreakdown } from '../corporate/balanceBreakdown/store/slice'
import { resetStoreCorpCashBreakdown } from '../corporate/cashBreakdown/store/slice'
import { resetStoreCorpCoverage } from '../corporate/coverage/store/slice'
import { resetStoreCorpEarningBreakdown } from '../corporate/earningBreakdown/store/slice'
import { resetStoreCorpLiquidity } from '../corporate/liquidity/store/slice'
import { resetStoreProfitability } from '../corporate/profitability/store/slice'
import { resetStoreQuickAssessmentCorporate } from '../corporate/quickAssessment/store/slice'
import { resetStoreRoaAndRoe } from '../corporate/roaAndRoe/store/slice'
import { resetStoreCorpSolvency } from '../corporate/solvency/store/slice'
import { resetStoreLifeInsBalanceBreakdown } from '../lifeInsurance/balanceBreakdown/store/slice'
import { resetStoreLifeInsCashBreakdown } from '../lifeInsurance/cashFlow/store/slice'
import { resetStoreLifeInsEarningBreakdown } from '../lifeInsurance/earningBreakdown/store/slice'
import { resetStoreLifeInsInsurancePremiumRevenue } from '../lifeInsurance/insurancePremiumRevenue/store/slice'
import { resetStoreLifeInsInsuranceSolvency } from '../lifeInsurance/insuranceSolvency/store/slice'
import { resetStoreLifeInsLiquidity } from '../lifeInsurance/liquidity/store/slice'
import { resetStoreLifeInsOperationalEfficiency } from '../lifeInsurance/operationalEfficiency/store/slice'
import { resetStoreLifeInsProfitability } from '../lifeInsurance/profitability/store/slice'
import { resetStoreLifeInsRoaAndRoe } from '../lifeInsurance/roaAndRoe/store/slice'
import { resetStoreNonBankAverageCost } from '../nonBank/averageCost/store/slice'
import { resetStoreNonBankBalanceBreakdown } from '../nonBank/balanceBreakdown/store/slice'
import { resetStoreNonBankCapitalAndLeverage } from '../nonBank/capitalAndLeverage/store/slice'
import { resetStoreNonBankCashBreakdown } from '../nonBank/cashFlow/store/slice'
import { resetStoreNonBankDepositAndCredit } from '../nonBank/depositAndCredit/store/slice'
import { resetStoreNonBankEarningBreakdown } from '../nonBank/earningBreakdown/store/slice'
import { resetStoreNonBankEarningQuality } from '../nonBank/earningQuality/store/slice'
import { resetStoreNonBankFundingStructure } from '../nonBank/fundingStructure/store/slice'
import { resetStoreNonBankLiquidity } from '../nonBank/liquidity/store/slice'
import { resetStoreNonBankLoanBookBreakdown } from '../nonBank/loanBookBreakdown/store/slice'
import { resetStoreNonBankQuickAssessment } from '../nonBank/quickAssessment/store/slice'
import { resetStoreNonLifeInsBalanceBreakdown } from '../nonLifeInsurance/balanceBreakdown/store/slice'
import { resetStoreNonLifeInsCashBreakdown } from '../nonLifeInsurance/cashFlow/store/slice'
import { resetStoreNonLifeInsEarningBreakdown } from '../nonLifeInsurance/earningBreakdown/store/slice'
import { resetStoreNonLifeInsInsurancePremiumRevenue } from '../nonLifeInsurance/insurancePremiumRevenue/store/slice'
import { resetStoreNonLifeInsInsuranceSolvency } from '../nonLifeInsurance/insuranceSolvency/store/slice'
import { resetStoreNonLifeInsLiquidity } from '../nonLifeInsurance/liquidity/store/slice'
import { resetStoreNonLifeInsOperationalEfficiency } from '../nonLifeInsurance/operationalEfficiency/store/slice'
import { resetStoreNonLifeInsProfitability } from '../nonLifeInsurance/profitability/store/slice'
import { resetStoreNonLifeInsRoaAndRoe } from '../nonLifeInsurance/roaAndRoe/store/slice'
import { resetStoreSecuBalanceBreakdown } from '../security/balanceBreakdown/store/slice'
import { resetStoreSecuBusinessPosition } from '../security/businessPosition/store/slice'
import { resetStoreSecuCashBreakdown } from '../security/cashFlow/store/slice'
import { resetStoreSecuEarningBreakdown } from '../security/earningBreakdown/store/slice'
import { resetStoreSecuEarningQuality } from '../security/earningQuality/store/slice'
import { resetStoreSecuFinancialAssets } from '../security/financialAsset/store/slice'
import { resetStoreSecuFundingAndLiquidity } from '../security/fundingAndLiquidity/store/slice'
import { resetStoreSecuLeverage } from '../security/leverage/store/slice'
import { resetStoreSecuOperatingIncome } from '../security/operatingIncome/store/slice'
import { resetStore } from '../store/slice'

const resetAllStore = (dispatch) => {
  dispatch(resetStore())
  dispatch(resetStoreQuickAssessmentCorporate())
  dispatch(resetStoreProfitability())
  dispatch(resetStoreRoaAndRoe())
  dispatch(resetStoreAssetManagementEfficiency())
  dispatch(resetStoreCorpBalanceBreakdown())
  dispatch(resetStoreCorpCashBreakdown())
  dispatch(resetStoreCorpCoverage())
  dispatch(resetStoreCorpEarningBreakdown())
  dispatch(resetStoreCorpLiquidity())
  dispatch(resetStoreCorpSolvency())
  dispatch(resetStoreBankAverageCost())
  dispatch(resetStoreBankBalanceBreakdown())
  dispatch(resetStoreBankCapitalAndLeverage())
  dispatch(resetStoreBankCashBreakdown())
  dispatch(resetStoreBankDepositAndCredit())
  dispatch(resetStoreBankEarningBreakdown())
  dispatch(resetStoreBankEarningQuality())
  dispatch(resetStoreBankFundingStructure())
  dispatch(resetStoreBankLiquidity())
  dispatch(resetStoreBankLoanBookBreakdown())
  dispatch(resetStoreBankQuickAssessment())
  dispatch(resetStoreNonBankAverageCost())
  dispatch(resetStoreNonBankBalanceBreakdown())
  dispatch(resetStoreNonBankCapitalAndLeverage())
  dispatch(resetStoreNonBankCashBreakdown())
  dispatch(resetStoreNonBankDepositAndCredit())
  dispatch(resetStoreNonBankEarningBreakdown())
  dispatch(resetStoreNonBankEarningQuality())
  dispatch(resetStoreNonBankFundingStructure())
  dispatch(resetStoreNonBankLiquidity())
  dispatch(resetStoreNonBankLoanBookBreakdown())
  dispatch(resetStoreNonBankQuickAssessment())
  dispatch(resetStoreSecuBalanceBreakdown())
  dispatch(resetStoreSecuBusinessPosition())
  dispatch(resetStoreSecuCashBreakdown())
  dispatch(resetStoreSecuEarningBreakdown())
  dispatch(resetStoreSecuEarningQuality())
  dispatch(resetStoreSecuFinancialAssets())
  dispatch(resetStoreSecuFundingAndLiquidity())
  dispatch(resetStoreSecuLeverage())
  dispatch(resetStoreSecuOperatingIncome())
  dispatch(resetStoreLifeInsBalanceBreakdown())
  dispatch(resetStoreLifeInsCashBreakdown())
  dispatch(resetStoreLifeInsEarningBreakdown())
  dispatch(resetStoreLifeInsInsurancePremiumRevenue())
  dispatch(resetStoreLifeInsInsuranceSolvency())
  dispatch(resetStoreLifeInsLiquidity())
  dispatch(resetStoreLifeInsOperationalEfficiency())
  dispatch(resetStoreLifeInsProfitability())
  dispatch(resetStoreLifeInsRoaAndRoe())
  dispatch(resetStoreNonLifeInsBalanceBreakdown())
  dispatch(resetStoreNonLifeInsCashBreakdown())
  dispatch(resetStoreNonLifeInsEarningBreakdown())
  dispatch(resetStoreNonLifeInsInsurancePremiumRevenue())
  dispatch(resetStoreNonLifeInsInsuranceSolvency())
  dispatch(resetStoreNonLifeInsLiquidity())
  dispatch(resetStoreNonLifeInsOperationalEfficiency())
  dispatch(resetStoreNonLifeInsProfitability())
  dispatch(resetStoreNonLifeInsRoaAndRoe())
}

export default resetAllStore
